// Auto-generated normalizer for table: CAR_BOOKING.ChecklistViaje
export function checklistViajeNormalize(row) {
  return {
    idChecklist: row.idChecklist ?? row.IdChecklist ?? row['idChecklist'] ?? 0,
    idReserva: row.idReserva ?? row.IdReserva ?? row['idReserva'] ?? 0,
    tipo: row.tipo ?? row.Tipo ?? row['tipo'] ?? '',
    combustible: row.combustible ?? row.Combustible ?? row['combustible'] ?? '',
    kmOdometro: row.kmOdometro ?? row.KmOdometro ?? row['kmOdometro'] ?? '',
    observaciones: row.observaciones ?? row.Observaciones ?? row['observaciones'] ?? '',
    fechaRegistro: row.fechaRegistro ?? row.FechaRegistro ?? row['fechaRegistro'] ?? null,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}